<div class="page-owner">
    <div class="header-owner">
        <div class="container owner-info d-grid d-md-flex">
            <div class="d-flex align-items-center d-sm-none verify-mobile">
                <div class="cont-icon-verify d-grid justify-content-center align-items-center">
                    <i class="fa-light fa-circle-check"></i>
                </div>
                <span class="user-verify">{{isBusiness?'Empresa verificada':'Espacio Verificado'}}</span>
            </div>
            <div class="img-owner-header"><img fallimg
                    src="{{urlImages}}{{owner.image_url ? owner.image_url : owner.img_url}}" alt="Imagen creador" /></div>

            <div class="container-owner-header">
                <div class="d-flex justify-content-center justify-content-between align-items-center title-mobile">
                    <p class="title-header m-0 mobile-align">{{ owner.name }}</p>
                    <div class="d-flex">
                        <span class="content-icon"><i *ngIf="sharedSupported"
                                class="fa-light d-md-none icon-options fa-arrow-up-from-bracket fa-lg"></i></span>
                    </div>
                </div>
                <div class="d-none d-sm-flex align-items-center">
                    <div class="cont-icon-verify d-grid justify-content-center align-items-center">
                        <i class="fa-light fa-circle-check"></i>
                    </div>
                    <span class="user-verify">{{isBusiness?'Empresa verificada':'Espacio Verificado'}}</span>
                </div>
                <div *ngIf="checkConditions" class="check-conditions">
                    <i class="fa-solid fa-circle-info icon-primary"></i>
                    <span (click)="openDialogConditions()">Ver condiciones generales de la organización.</span>
                </div>
                <div class="description-user" [innerHTML]="owner.description"></div>
            </div>
        </div>
        <div class="ellipse-header"></div>
    </div>

    <!-- Tab toggle -->
    <div class="tab-toggle-wrapper" *ngIf="owner.id && hasAbonos">
        <div class="tab-toggle">
            <button class="tab-btn" [class.active]="activeTab === 'events'" (click)="setActiveTab('events')">
                Eventos
            </button>
            <button class="tab-btn" [class.active]="activeTab === 'abonos'" (click)="setActiveTab('abonos')">
                Abonos
            </button>
        </div>
    </div>

    <div class="container-events-owner">
        <!-- Events tab -->
        <div *ngIf="activeTab === 'events'" class="container owner-results">
            <p class="text-center title-owner" *ngIf="!results">Este creador no tiene ningún evento activo</p>
            <div *ngIf="owner.id" class="tab-events-owner">
                <app-infinity-scroll [isBusiness]="isBusiness" [idCreator]="owner.id" [teatroIdeal]="teatroIdeal"
                    [eventAfter]="'active'" (results)="existsResults($event)"></app-infinity-scroll>
            </div>
        </div>

        <!-- Abonos tab -->
        <div *ngIf="activeTab === 'abonos' && owner.id">
            <app-owner-abonos [companyId]="companyId" [ownerName]="owner.name"></app-owner-abonos>
        </div>
    </div>
</div>
